/**
 * Brand assets — same CDN paths as the main Gridbind app (e.g. VarexeLogo).
 */
export const VAREXE_LOGO_MINIMAL_CDN_URL =
  'https://cdn.gridbind.com/images/logo/gridbind-logo-minimal.png';
